const styles = (theme) => ({
  boxIcon: {
    position: "absolute",
    top: 0,
    right: 0,
    minWidth: "40px",
    height: "20px",
    padding: 1,
    borderTopRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
  },
  boxIconStyleOs: {
    borderBottomLeftRadius: "16px",

    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    padding: "0 9px",
  },
  titleStatusCard: {
    fontSize: "9px",
    fontWeight: 900,
    color: theme.palette.white.main,
  },
  iconStatus: { fontSize: "13px" },
});

export default styles;
